module.exports = __webpack_public_path__ + "static/media/qrImg.dcbfa391.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/qrImg.png
// module id = 2026
// module chunks = 0